export const places = 'place/';
export const placesInGoals = 'places/';
export const channels = 'channel';
export const channelsSigtim = 'sigtim/channels';
export const pdvSigtim = 'sigtim/pdv';
export const brand = 'brand';
export const gadget = 'gadget';
export const gadgetCategory = 'gadget-category';
export const relatedChannels = 'channel/related';
export const goalsValidation = 'goal-validation';
export const goalsTransfer = 'goal-transfer';
export const importMacroGoal = 'import-macro-goal';

export const regionals = 'view';
export const relatedRegionals = 'view/related';

export const quizz = 'quizz';
export const createQuizz = 'quizz/entire';
export const storeQuizz = 'quizz/available-for';

export const cities = 'util/cities/';
export const address = 'util/cep/';
export const apiGoogle = '';
export const visits = 'visit';
export const view = 'view';
export const location = '/util/address/';
export const reset = 'reset/user';
export const sendToken = 'reset/user/request';
export const changePasswordFromInterface = 'reset/user/password';
export const enablePasswordChange = '/settings';
export const auth = 'auth/login';
export const logout = 'auth/logout';
export const verifyUser = 'auth/me';
export const checkAllowedSystem = 'auth/checkAllowedSystem';
export const distributors = '/distributor';

export const user = 'user';
export const relatedUsers = 'user/by-view';

export const viewSale = '/view_sale';
export const sale = '/sale';
export const segments = '/util/setup';
export const importation = 'import/user';
export const role = 'role';
export const userWithSale = 'user/index/with-sales';
export const saleLogs = '/sale_logs';
export const importationStatus = '/import/importarTimLog';
export const simCards = '/sigtim/simcard';
export const ddds = '/ddd';
export const goalsDistribuition = '/goal-distributions';
export const criticPoint = '/critic-point';
export const placeSegments = '/place_segments';
export const gateway = '/sigtim/auditoria/logbko';
export const views = '/view';
export const vendaCantadaRegionais = '/venda-cantada/regionais';
export const viewsSigTim = '/view/sigtim';

export const tokenVisit = '/powerbi/tokenVisit';
export const tokenVisitCheckList = '/powerbi/tokenVisitCheckList';
export const tokenPlanosAcao = '/powerbi/tokenPlanosAcao';
export const tokenSigtimRecarga = '/powerbi/tokenSigtimRecarga';
export const tokenSigtimRastreabilidadeRecarga = '/powerbi/tokenSigtimRastreabilidadeRecarga';
export const tokenSigtimRastreabilidadeChip = '/powerbi/tokenSigtimRastreabilidadeChip';
export const tokenSigtimQualidade = '/powerbi/tokenSigtimQualidade';
export const tokenPainelGerencial = '/powerbi/tokenPainelGerencial';
export const tokenSigtimCapilaridade = '/powerbi/tokenSigtimCapilaridade';
export const tokenHDCIntegracao = '/powerbi/tokenHDCIntegracao';
export const tokenOperacaoAMSTIM = '/powerbi/tokenOperacaoAMSTIM';
export const tokenAccessRequests = '/powerbi/tokenAccessRequests';
export const tokenSigtimInvasoesPenalidades = '/powerbi/tokenSigtimInvasoesPenalidades';
export const tokenSigtimPenetracaoChip = '/powerbi/tokenSigtimPenetracaoChip';
export const tokenSigtimMeuPainel = '/powerbi/tokenSigtimMeuPainel';
export const tokenSigtimPaliativo = '/powerbi/tokenSigtimPalliative';
export const tokenSigtimDrillDownChip = '/powerbi/tokenSigtimDrillDownChip';
export const tokenSigtimRastreabilidadeApis = '/powerbi/tokenSigtimApiTraceability';
export const tokenLastAccessUser = '/powerbi/tokenManagementGuActiveUsers';
export const tokenAccessControlDepartmentalSystems = '/powerbi/tokenDepartmentalSystemsAction';
export const tokenUserManagement = '/powerbi/tokenManagementGuActiveUsers';
export const tokenHomeBroker = '/powerbi/tokenHomerBroker';
export const tokenSigtimImportManagement = '/powerbi/tokenSigtimImportManagement';
export const tokenTimClosing = '/powerbi/tokenTimClosing';

export const pdvCapillarity = '/powerbi/capillarity';
export const pdvFinancial = '/powerbi/financial';

export const tokenCapillarity = '/management-pdv/powerbi/capillarity';
export const tokenFinancial = '/management-pdv/powerbi/financial';

export const importationDownloadStatus = '/import/arquivoRetorno';
export const rechargeBase = '/sigtim/relatorios/exportaRecargas';
export const chipBase = '/sigtim/simcard/relatorio_filtros';
export const capillarityBase = '/sigtim/pdv/export';
export const beepBase = '/sigtim/bipagem/exportar';
export const importHistoryBase = 'sigtim/relatorios/exportar-logs-processamento-importacoes';
export const duplicateActivation = 'sigtim/relatorios/ativacoesDuplicadas';
export const exportDuplicateBase = 'sigtim/relatorios/exportaAtivacoesDuplicadas';
export const budgetEndPoint = 'budgets';
export const ChannelHQ = '/channel/userhqchannel';
export const viewGoals = 'goals/views';
export const cv = '/sale-consultants';
export const criticalPoints = '/critical-points';
export const goalTransferApproval = 'goal-distributions/transfer-channel-view';
export const businessPlans = '/business-plans';
export const businesPlanSegments = '/business-plan-segments';
export const oldGoals = '/goals/former';
export const oldGoalsDownload = '/goals/history/';
export const oldGoalsBU = '/goals/history-bu/';
export const oldGoalsBUDownload = '/goals/history-bu/';
export const submitToRegionalAdjustment = '/goals/submit-to-regional-adjustment/';
export const submitToPlanningApproval = '/goals/submit-to-planning-approval/';
export const submitToHqIntelligenceApproval = '/goals/submit-to-hq-approval/';
export const planningGoalsValidation = '/goal-validation/planning';
export const distributionBetweenPDVS = '/place-goal-distributions';
export const downloadBudgetExemple = '/budgets/example';
export const plans = '/plan';
export const storeInfo = '/termo/storeInfo';
export const planInfo = '/termo/plansInfo';
export const saveReportTerm = '/termo/saveReportTerm';

export const importCsvTerm = '/term/import-csv';
export const importHistoryTerm = '/term/import-csv/list';
export const importHistoryTermCancel = '/term/import-csv/cancel';
export const termShowFinesTable = '/term/show/fines_table';
export const termAwsDownload = '/aws/download';

export const km = '/km';
export const historic = '/api/km/historic';
export const exportCoverSheet = '/api/km/historic/export';
export const myAddresses = '/my-addresses';
export const exportCoverSheetReport = '/api/km/report/export';

export const importarTimLog = '/import/importarTimLog';
export const listImportsTypes = '/import/listImportsTypes';
export const logImportProcess = 'sigtim/relatorios/logs-processamento-importacoes';
export const statusChip = '/sigtim/simcard/status-chip';
export const tradutorDePara = '/sigtim/depara';
export const deParaNotAssigned = '/sigtim/depara/not-assigned';
export const exportDePara = '/sigtim/depara/export';

export const protocol = '/sigtim/protocol';
export const exportProtocol = '';
export const confidenceLoginSigtim = '/auth/confidence/sigtim';

export const listAccessReport = '/tracking/report';
export const exportAccessReport = '/tracking/report-csv';
export const accessTracking = '/tracking';

export const distributorsAllOrUserToAssociate = '/distributor/allOrUserToAssociate';

export const homeBrokerList = '/sigtim/homebroker';
export const approveReprove = '/sigtim/homebroker';

export const historyList = 'api/pdv-management/list';

export const pdv = {
  fileType: {
    creditLimit: '/api/pdv-management/export/creditLimit',
    advance: '/api/pdv-management/export/advance',
    nonCompliance: '/api/pdv-management/export/nonCompliance',
    novation: '/api/pdv-management/export/reportNovation'
  },
  uploadFile: 'api/pdv-management/uploadFile',
  list: 'api/pdv-management/list'
};

export const listHistoryImport = 'sigtim/manual/list';
export const listManualCurrent= 'sigtim/manual/current';
export const createManualUpload= 'sigtim/manual/upload';
export const createManualNew = 'sigtim/manual';
export const ManualDelete = 'sigtim/manual';
export const ManualDownload ='sigtim/manual/download';